import React from 'react';

require('./PaymentPreference.scss');

const PaymentPreference = () => (
  <div className="paymentPreferenceContainer">
    <div className="paymentPreferenceTitle">Select Payment Preference</div>
    <input checked className="radioBtn" type="radio" name="paymentPref" id="sampleCollection" />
    <label className="radioBtnLabel" htmlFor="sampleCollection">
      Pay at the time of sample collection
    </label>
  </div>
);

export default PaymentPreference;
